import { UserVestingData } from "../../../types/UserVesting";

export class UserVesting {
    totalAmount: number;
    claimedAmount: number;
    claimStart: Date;
    claimEnd: Date;
  constructor(data: UserVestingData ) {
      this.totalAmount = (Number(data.totalAmount * BigInt(100) / BigInt(10**18)) / 100);
      this.claimedAmount = (Number(data.claimedAmount * BigInt(100) / BigInt(10**18)) / 100);
      this.claimStart = new Date(Number(data.claimStart * BigInt(1000)));
      this.claimEnd = new Date(Number(data.claimEnd * BigInt(1000)));
  }
}
